import { failToast } from '@utils/toast';
import Modal from '@roo/roo/Modal';
import pageJump from '@projects/Shell/utils/pageJump';
import * as API from '../../api';
import { RootDispatch } from '..';
import { IAllPoiList, IKangarooInfo, IBusinessStatus } from '../../api/define';

export interface IState {
    poiList: IAllPoiList[];
    poiKangarooInfo: IKangarooInfo;
    poiBusinessStatus: IBusinessStatus;
    /** 未读站内信消息数量 */
    unReadNotificationCount: number;
    /** 是否是品牌账号 */
    auth: boolean;
}

const shellHeader = {
    name: 'shellHeader',
    state: {
        poiList: [],
        poiKangarooInfo: {
            name: '',
            status: 0,
            url: '',
            version: '',
        },
        poiBusinessStatus: {
            code: 0,
            hasSpecialShippingTime: false,
            restType: 0,
            shippingTimeDesc: '',
            status: 1,
            statusDescInfo: '',
            subStatus: 0,
            wmPoiStatusDesc: '',
            valid: 1,
        },
        unReadNotificationCount: 0,
        auth: false,
    } as IState,
    reducers: {
        setData(state: IState, payload: Partial<IState>) {
            return {
                ...state,
                ...payload,
            };
        },
        setBusinessStatusInfo(state: IState, payload: string) {
            state.poiBusinessStatus = { ...state.poiBusinessStatus, wmPoiStatusDesc: payload };
            return {
                ...state,
            };
        },
        updateUnReadNotificationCount(state: IState, payload: number) {
            return {
                ...state,
                unReadNotificationCount: payload,
            };
        },
    },
    effects: (dispatch: RootDispatch) => ({
        /** 获取门店 袋鼠店长状态 */
        async getPoiKangarooInfo() {
            try {
                const response = await API.getPoiKangarooInfo();
                dispatch.shellHeader.setData({ poiKangarooInfo: response });
            } catch (e) {
                failToast('获取袋鼠店长状态失败');
            }
        },

        /** 获取门店营业状态 */
        async getBusinessStatus() {
            try {
                const response = await API.getBusinessStatus();
                dispatch.shellHeader.setData({ poiBusinessStatus: response });
            } catch (e) {
                failToast('获取门店营业状态失败');
            }
        },

        /** 修改门店营业状态 */
        async changeBusinessStatus(status: number) {
            try {
                const res = await API.changeBusinessStatus({ status });
                if (res.code === 100) {
                    Modal.confirm({
                        title: '合同到期',
                        children:
                            '尊敬的商家，您好：因品牌与平台签约的合同已到期，门店恢复营业失败。您可在品牌与平台完成续签后恢复营业。您可通过品牌方联系品牌业务经理反馈意见和获得更多解释说明。',
                        confirmText: '我知道了',
                        showCancelButton: false,
                    });
                } else if (res.code !== 0) {
                    failToast('更新失败');
                } else {
                    dispatch.shellHeader.setBusinessStatusInfo(res.data.strWmPoiStatusDesc);
                    const { goodsCheckCode, goodsCheckDesc } = res.data;
                    if (goodsCheckCode !== undefined && goodsCheckDesc !== undefined) {
                        const tips = `<div>${goodsCheckDesc.lineOne ||
                            ''}</div><div>${goodsCheckDesc.lineTwo || ''}</div>`;
                        if (goodsCheckCode === -1) {
                            Modal.confirm({
                                title: '温馨提示',
                                children: tips,
                                confirmText: '设置商品',
                                cancelText: '稍后设置',
                                onConfirm: () => {
                                    pageJump.go(
                                        '/gw/static_resource/product?pageFrom=headNav#/listView',
                                    );
                                },
                            });
                        }
                    }
                }
            } catch (e) {
                failToast('更新失败');
            }
        },
        /** 获取账号品牌属性 310 600 */
        async getBetterAuth() {
            try {
                const response = await API.getBetterAuth();
                dispatch.shellHeader.setData({ auth: response.auth || false });
            } catch (e) {
                failToast('获取品牌账号数据失败');
            }
        },
    }),
};

export default shellHeader;
